export const TimeInMinutes = 20;
